<template>
  <section class="invoice-add-wrapper">
      <BCard v-if="(settings.company_name==null || settings.cif==null)">
        <p>No puedes crear una factura si no has añadido los datos de facturación "Razón social" y "CIF". Por favor, en el apartado "Datos de facturación" de este <span><b-link :to="{ name: 'settings'}">enlace</b-link></span> cúbrelos.</p>
      </BCard>
      <BRow v-else class="invoice-add"  >
      <!-- Col: Left (Invoice Container) -->
      <BCol cols="12" xl="9" md="8">
        <BForm @submit.prevent>
          <BCard no-body class="invoice-preview-card">
            <!-- Header -->
            <BCardBody class="invoice-padding pb-0">
              <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <BImg :src="appLogoImage" width="50" />
                    <h3 class="text-primary invoice-logo"> {{ appName }} </h3>
                  </div>
                  <div>
                    <BCardText class="mb-0">{{ invoice.settings_company_name }}</BCardText>
                    <BCardText class="mb-0">{{ invoice.settings_cif }}</BCardText>
                    <BCardText class="mb-25" v-if="invoice.settings_address"> {{ invoice.settings_address }} </BCardText>
                    <BCardText class="mb-0" v-if="invoice.settings_postal_code && invoice.settings_city">{{invoice.settings_postal_code}} - {{invoice.settings_city}}</BCardText>
                    <BCardText class="mb-0" v-if="invoice.settings_province && invoice.settings_country">{{invoice.settings_province}}, {{invoice.settings_country}}</BCardText>
                    <BCardText class="mb-0">{{ invoice.settings_phone }}</BCardText>
                  </div>
                </div>

                <!-- Header: Right Content -->
                <div class="invoice-number-date mt-md-0 mt-2">
                  <div class="d-flex align-items-center mb-1">
                    <span class="title"> {{ $t('Emit Date') }}: </span>
                    <flatPickr v-model="invoice.emit_date" class="form-control invoice-edit-input" disabled :config="{dateFormat: 'd-m-Y'}" />
                  </div>

                  <div class="d-flex align-items-center">
                    <span class="title"> {{$t('Due Date')}}: </span>
                    <flatPickr v-model="invoice.payment_date" class="form-control invoice-edit-input" :config="{ minDate: invoice.emit_date, dateFormat: 'd-m-Y' }" />
                  </div>
                </div>
              </div>
            </BCardBody>

            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Invoice Client & Payment Details -->
            <BCardBody class="invoice-padding pt-0">
              <BRow class="invoice-spacing">

                <!-- Col: Invoice To -->
                <BCol cols="12" xl="6" class="mb-lg-1">
                  <h6 class="mb-2"> {{ $t('Invoice To') }}: </h6>
                  
                  <BCol >
                      <label>Cliente</label>
                      <!-- Select Client -->
                      <div class="d-flex">
                        <VueAutosuggest class="w-100" v-model="invoice.customer_billing_full_name" :suggestions="customersSuggestions" :limit="10" :input-props="{ id: 'autosuggest_input2', class: 'form-control', placeholder: 'Selecciona un cliente' }" @selected="val => updateCustomerForm(val.item)" @input="onCustomerInputChange" >
                            <template slot-scope="{suggestion}">
                              <span class="my-suggestion-item">{{ ` ${suggestion.item.search_name}` }}</span>
                            </template>
                        </VueAutosuggest>
                        <BButton variant="flat-info" class="btn-icon ml-1" @click="isSidebarActive=true">
                          <FeatherIcon size="18" icon="PlusIcon" />
                        </BButton>  
                    </div>
                  </BCol>
                  <div>
                    <TextInputValidated  v-if="invoice.student_id && invoice.account_id" :vsModel.sync="invoice.studentName" vsName="Estudiante"  vsLabel="bank_account" :vsDisabled="true" />
                  </div>    
                </BCol>

                
                <!-- Col: Payment Details -->
                <BCol xl="6" cols="12" class="mt-xl-0 mt-2 justify-content-end d-xl-flex d-block" >
                  <BRow v-if="invoice.customer_billing_nif != null && (type=='invoice' && !(invoice.customer_billing_full_name==null || invoice.customer_billing_nif==null || invoice.customer_billing_address==null || invoice.customer_billing_province==null || invoice.customer_billing_country==null || invoice.customer_billing_postal_code==null || invoice.customer_billing_postal_code==null) )">
                    <h6 class="mb-2 col-12"> {{ $t('Payment Details') }}: </h6>
                    <TextInputValidated v-if="invoice.payment_method=='Domiciliaciones de pago' || invoice.payment_method=='Transferencias bancarias' " :vsModel.sync="invoice.bank_account_iban" vsName="Cuenta bancaria"  vsLabel="bank_account" :vsDisabled="true" />
                    <TextInputValidated vsMd="6" v-if="invoice.payment_method=='Domiciliaciones de pago' || invoice.payment_method=='Transferencias bancarias' " :vsModel.sync="invoice.bank_account_swift" vsName="SWIFT/BIC"  vsLabel="bank_account" :vsDisabled="true" />
                    <TextInputValidated :vsModel.sync="invoice.customer_billing_full_name" vsName="Nombre"  vsLabel="bank_name" vsMd="6" :vsDisabled="true" />
                    <TextInputValidated :vsModel.sync="invoice.customer_billing_nif" vsName="DNI"  vsLabel="bank_nif" vsMd="6" :vsDisabled="true" />
                    <TextInputValidated :vsModel.sync="invoice.customer_billing_city" vsName="Ciudad"  vsLabel="bank_city" vsMd="6" :vsDisabled="true" />
                    <TextInputValidated :vsModel.sync="invoice.customer_billing_postal_code" vsName="Código postal"  vsLabel="bank_postal_code" vsMd="6" :vsDisabled="true" />
                    <TextInputValidated :vsModel.sync="invoice.customer_billing_province" vsName="Provincia"  vsLabel="bank_province" vsMd="6" :vsDisabled="true" />
                    <TextInputValidated :vsModel.sync="invoice.customer_billing_country " vsName="País"  vsLabel="bank_country" vsMd="6" :vsDisabled="true" />
                    <BFormGroup cols="12" v-if="invoice.payment_method=='Transferencias bancarias' && invoice.group.bank_accounts.length>1" :label="$t('Cuenta bancaria')" label-for="payment-method">
                      <vSelect  v-model="invoice.bank_account_id" :options="invoice.group.bank_accounts" label="name" input-id="payment-method" class="payment-selector" :clearable="false"/>
                    </BFormGroup>

                  </BRow>



                  <BRow v-if="invoice.customer_billing_nif != null && (type=='invoice' && (invoice.customer_billing_full_name==null || invoice.customer_billing_nif==null || invoice.customer_billing_address==null || invoice.customer_billing_province==null || invoice.customer_billing_country==null || invoice.customer_billing_postal_code==null || invoice.customer_billing_postal_code==null) ) ">
                    <ul>
                      <li>Este cliente no tiene todos los datos de facturación.</li> 
                      <li>Revisa que los campos 'NIF', 'Dirección postal', 'Población', 'Código postal', 'Provincia' y 'País'
                      estén cubiertos.</li>
                      <li> Si es un estudiante también puedes asociarle una cuenta.</li>
                    </ul>
                  </BRow>

                  <BRow v-if="invoice.customer_billing_nif != null && type=='receipt'">
                    <h6 class="mb-2"> {{ $t('Payment Details') }}: </h6>
                    <TextInputValidated :vsModel.sync="invoice.customer_billing_nif" vsName="NIF"  vsLabel="bank_account" :vsDisabled="true" />
                    <TextInputValidated class="pt-1" :vsModel.sync="invoice.customer_billing_full_name" vsName="Nombre"  vsLabel="bank_name" :vsDisabled="true" />
                    <TextInputValidated class="pt-1" :vsMd="8" v-if="invoice.payment_method=='Domiciliaciones de pago' || invoice.payment_method=='Transferencias bancarias' " :vsModel.sync="invoice.bank_account_iban" vsName="Cuenta bancaria"  vsLabel="bank_account" :vsDisabled="true" />
                    <TextInputValidated class="pt-1" :vsMd="4" v-if="invoice.payment_method=='Domiciliaciones de pago' || invoice.payment_method=='Transferencias bancarias' " :vsModel.sync="invoice.bank_account_swift" vsName="SWIFT/BIC"  vsLabel="bank_account" :vsDisabled="true" />

                    <BCol>
                      <BFormGroup v-if="( invoice.payment_method=='Transferencias bancarias') && invoice.group.bank_accounts.length>1" :label="$t('Cuenta bancaria')" label-for="payment-method">
                        <vSelect  v-model="invoice.bank_account_id" :options="invoice.group.bank_accounts" :reduce="bank => bank.id" label="name" input-id="payment-method" class="payment-selector" :clearable="false"/>
                      </BFormGroup>
                    </BCol>

                  </BRow>
                </BCol>
              </BRow>
            </BCardBody>

            <!-- Items Section -->
            <BCardBody class="invoice-padding ">
              <div ref="form" class="repeater-form" :style="{height: trHeight}">
                <BRow v-for="(item, index) in invoice.items" :key="index" ref="row" class="pb-2">

                  <!-- Item Form -->
                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <BCol cols="12">

                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-none d-lg-flex">
                      <BRow class="flex-grow-1 px-1">
                        <!-- Single Item Form Headers -->
                        <BCol cols="12" lg="4"> {{ $t('Item') }} </BCol>
                        <BCol cols="12" lg="2"> {{ $t('Amount') }}</BCol>
                        <BCol cols="12" lg="2"> {{ $t('Quantity') }} </BCol>
                        <BCol cols="12" lg="2"> {{ $t('Price') }} </BCol>
                        <BCol cols="12" lg="2"> Precio + impuestos </BCol>

                      </BRow>
                      <div class="form-item-action-col" />
                    </div>

                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <BRow class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->
                        <BCol cols="12" lg="4" >
                          <label class="d-inline d-lg-none">{{ $t('Item') }}</label>
                          <VueAutosuggest v-model="item.item" :suggestions="itemsSuggestions" :limit="10" :input-props="{ id: 'autosuggest_input', class: 'form-control', placeholder: 'Selecciona una producto' }" @selected="val => updateItemForm(index, val.item, invoice)" @input="onItemInputChange" >
                            <template slot-scope="{suggestion}">
                              <span class="my-suggestion-item">{{ ` ${suggestion.item.name}` }}</span>
                            </template>
                          </VueAutosuggest>
                        </BCol>
                        
                        <BCol cols="12" lg="2">
                          <label class="d-inline d-lg-none">{{ $t('Amount') }}</label>
                          <BFormInput v-model="item.amount" type="number" class="mb-2" :disabled="item.item == ''"/>
                        </BCol>
                        <BCol cols="12" lg="2">
                          <label class="d-inline d-lg-none">{{ $t('Quantity') }}</label>
                          <BFormInput v-model="item.quantity" type="number" class="mb-2" :disabled="item.item == ''" />
                        </BCol>
                        <BCol cols="12" lg="2" >
                          <label class="d-inline d-lg-none">{{ $t('Price') }}</label>
                          <p class="mb-1"> {{ formatCurrency(getItemTaxableBase(item))}} </p>
                        </BCol>
                        <BCol cols="12" lg="2" >
                          <label class="d-inline d-lg-none">Precio + impuestos </label>
                          <p class="mb-1"> {{ formatCurrency(item.total) }} </p>
                        </BCol>

                        <BCol cols="12" lg="10" >
                          <label for="description_input" class="d-inline d-lg-none">{{ $t('Description') }}</label>
                          <BFormTextarea v-model="item.observations" max-rows="3" name="description_input" class="mb-2 mb-lg-0" :disabled="item.item == ''"/>
                        </BCol>
                        <BCol>
                          <p class="mb-0"> {{ $t('Discount') }}: {{ item.discount }}% </p>
                          <p v-if="applyVAT" class="mb-0"> IVA: {{ item.vat ? item.vat + '%' : '' }} </p>
                          <p v-if="(invoicePit!=null && applyPIT)" class="mb-0"> IRPF: {{ item.pit  ? item.pit : '0' }}% </p>
                        </BCol>

                        <BCol cols="12" class="pt-2">
                          <BButton v-b-toggle:advanced-options variant="flat-secondary" class="m-0 p-0 d-flex align-items-center">          
                            <feather-icon icon="ChevronDownIcon" size="16"/> <small>Más</small>
                          </BButton>
                          <BCollapse id="advanced-options">
                            <BRow class="pt-2">
                            <!-- Field: Discount -->
                            <BCol cols="4">
                              <BFormGroup label="Descuento %" :label-for="`setting-item-${index}-tax-1`">
                                <BFormInput v-model="item.discount" :id="`setting-item-discount`" type="number"/>
                              </BFormGroup>
                            </BCol>

                            <!-- Field: IVA -->
                            <BCol cols="4" v-if="applyVAT">
                              <BFormGroup label="IVA" :label-for="`setting-item-${index}-tax-0`">
                                <vSelect v-if="vatsOptions" v-model="item.vat"  :options="vatsOptions"  label="name" :reduce="option => option.value" :input-id="`setting-item-${index}-tax-0`" :clearable="false" :disabled="item.is_supplied"/>
                              </BFormGroup>
                            </BCol>
                            <BCol v-else cols="4"></BCol>

                            <!-- Field: IRPF -->
                            <BCol cols="4" v-if="(invoicePit && applyPIT)">
                              <BFormGroup v-if="pitsOptions" label="IRPF" :label-for="`setting-item-${index}-tax-1`">
                                <vSelect v-model="item.pit" :disabled="item.is_supplied" :options="pitsOptions" label="name" :reduce="option => option.value" :input-id="`setting-item-${index}-tax-1`" :clearable="true"/>
                              </BFormGroup>
                            </BCol>
                            <BCol v-else cols="4"></BCol>
                            <BCol cols="4"> 
                              <BFormGroup label="Tipo" :label-for="`setting-item-${index}-tax-0`">
                                <vSelect v-if="itemTypeOptions" v-model="item.is_supplied" @input="(val) => onItemTypeInput(item, val)" :options="itemTypeOptions"  label="text" :reduce="option => option.value" :input-id="`setting-item-${index}-tax-0`" :clearable="true"/>
                              </BFormGroup>
                            </BCol>
                            <BCol cols="4" v-if="item.is_supplied===false"> 
                              <BFormGroup label="Cuenta contable" :label-for="`setting-item-${index}-tax-0`">
                                <vSelect v-if="accountingAccountOptions" v-model="item.accounting_account" @input="(val) => onAccountingInput(item, val)"  :options="accountingAccountOptions"  label="search_name" :input-id="`setting-item-${index}-tax-0`" :clearable="true"/>
                              </BFormGroup>
                            </BCol>
                            <BCol  v-if="item.accounting_account && item.is_supplied===false" cols="4"> 
                              <BFormGroup label="Subuenta contable" :label-for="`setting-item-${index}-tax-0`">
                                <vSelect v-model="item.accounting_subaccount"  :options="item.accounting_account.accounting_subaccounts"  label="search_name" :reduce="option => option.id" :input-id="`setting-item-${index}-tax-0`" :clearable="true"/>
                              </BFormGroup>
                            </BCol>
                           </BRow>
                          </BCollapse>
                        </BCol>
                        

                        
                        
                      </BRow>
    
                      
                      <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                        <feather-icon size="16" icon="XIcon" class="cursor-pointer" @click="removeItem(index)"/>
                        <!-- <feather-icon :id="`form-item-settings-icon-${index}`" size="16" icon="SettingsIcon" @click="changeToCurrentTax(index)" class="cursor-pointer"/> -->

                        <!-- Setting Item Form -->
                        <!-- <BPopover :ref="`form-item-settings-popover-${index}`" :target="`form-item-settings-icon-${index}`" triggers="click" placement="lefttop" :disabled="item.item == ''"> -->
                        <!-- </BPopover> -->
                      </div>
                    </div>
                  </BCol>
                 
                </BRow>
              </div>
              <BButton v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary" @click="addNewItemInItemForm"> {{$t('Add Item')}} </BButton>
            </BCardBody>

            <!-- Invoice Description: Total -->
            <BCardBody class="invoice-padding pb-0">
              <BRow>

                <!-- Col: Sales Person -->
                <BCol cols="12" md="6" class="mt-md-0 mt-3 d-flex align-items-center" order="2" order-md="1">
                  <label for="invoice-data-sales-person" class="text-nowrap mr-50">{{ $t('User') }}:</label>
                  <BFormInput id="invoice-data-sales-person" v-model="invoice.user_full_name" disabled/>
                </BCol>

                <!-- Col: Total -->
                <BCol cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                  <div class="invoice-total-wrapper">
                    <div class="invoice-total-item">
                        <p class="invoice-total-title"> Subtotal: </p>
                        <p class="invoice-total-amount"> {{formatCurrency(invoice.subtotal)}} </p>
                    </div>

                    <div class="invoice-total-item">
                        <p class="invoice-total-title"> Descuentos: </p>
                        <p class="invoice-total-amount"> {{formatCurrency(invoice.discounts)}} </p>
                      </div>

                    <div class="invoice-total-item">
                        <p class="invoice-total-title"> Base imponible: </p>
                        <p class="invoice-total-amount"> {{formatCurrency(invoice.taxableBase)}} </p>
                    </div>

                    <div class="invoice-total-item" v-for="(vat, index) in invoice.vats" :key="vat.value+'vat'">
                          <p class="invoice-total-title"> IVA {{vat.value}}%</p>
                          <p class="invoice-total-amount"> {{formatCurrency(vat.price)}}</p>
                    </div>

                    <div class="invoice-total-item" v-for="(pit, index) in invoice.pits" :key="pit.value+'pit'">
                          <p class="invoice-total-title"> IRPF {{ pit.value }}%</p>
                          <p class="invoice-total-amount"> {{ formatCurrency(pit.price)}}</p>
                    </div>

                    <hr class="my-50">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title"> {{ $t('Total') }}: </p>
                      <p class="invoice-total-amount"> {{ formatCurrency(invoice.amount)}}</p>
                    </div>
                  </div>
                </BCol>
              </BRow>
            </BCardBody>

            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Note -->
            <BCardBody class="invoice-padding pt-0">
              <span class="font-weight-bold">{{ $t('Note') }}: </span>
              <BFormTextarea v-model="invoice.note" />
            </BCardBody>
          </BCard>
        </BForm>
      </BCol>

      <!-- Right Col: Card -->
      <BCol cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">

        <div class="row">
          <!-- Action Buttons -->
          <BCard class="mt-2 mt-md-0 col-12 order-2 order-md-1" >
            <BButton v-ripple.400="'rgba(113, 102, 240, 0.15)'" id="submitbutton" variant="primary" @click="submit" block> {{ $t('Save') }} </BButton>
            <BButton variant="outline-danger" :to="{ name: 'invoices' }" block>{{ $t('Cancel') }}</BButton>
          </BCard>

          <!-- Payment Method -->
          <div class="col-12 order-1 order-md-2" v-if="paymentMethodsOptions" >
            <BFormGroup v-if="groupsOptions && groupsOptions.length>1" :label="$t('Group')" label-for="payment-method">
              <vSelect  v-model="invoice.group" :options="groupsOptions" label="name" input-id="payment-method" class="payment-selector" :clearable="false"/>
            </BFormGroup>
            <BFormGroup v-if="(invoice.group && (type=='receipt'))" label="Serie" label-for="serie">
              <vSelect :disabled="invoice.group.receipt_series.length==1" v-model="invoice.serie" @input="setEconomicActivity" :options="invoice.group.receipt_series" label="search_name" input-id="serie" class="payment-selector" :clearable="false"/>
            </BFormGroup>

            <BFormGroup v-if="(invoice.group && (type=='invoice'))" label="Serie" label-for="serie2">
              <vSelect :disabled="invoice.group.invoice_series.length==1" v-model="invoice.serie" :options="invoice.group.invoice_series" label="search_name" input-id="serie2" class="payment-selector" :clearable="false"/>
            </BFormGroup>

            <BFormGroup label="Actvidad económica" label-for="economic_activity">
              <vSelect v-model="invoice.economic_activity_id" :options="economicActivityOptions" :reduce="ec => ec.id" label="name" class="payment-selector" :clearable="false"/>
            </BFormGroup>

            <BFormGroup :label="$t('Payment method')" label-for="payment-method">
              <vSelect v-model="invoice.payment_method" :reduce="pay => pay.name" :options="paymentMethodsOptions" label="name"  class="payment-selector" :clearable="false"/>
            </BFormGroup>

            <BFormGroup v-if="cashesOptions && showCashes" :label="$t('Caja')" label-for="cash" >
              <vSelect  v-model="invoice.cash_id" :reduce="cash => cash.id" :options="cashesOptions" label="name" input-id="payment-method" class="payment-selector" :clearable="false"/>
            </BFormGroup>

            <BFormGroup class="mb-1" stacked >
              <BFormCheckbox v-model="invoice.paid"> Pagada </BFormCheckbox>
            </BFormGroup>
            <BFormRadioGroup v-model="type"  class="price-range-defined-radio-group d-flex " stacked >
              <BFormRadio  class="pr-1" v-for="p in typeOptions" :key="p.text" :value="p.value" >{{ p.text }} </BFormRadio>
            </BFormRadioGroup>
          </div>
        </div>
      </BCol>
    </BRow>
    <InvoiceSidebarAddNewCustomer parent="invoice" @new-student-added="fetchStudents" @new-account-added="fetchAccounts"/>
  </section>
</template>

<script>

import { BRow, BCol, BCard, BCardBody, BButton, BCardText, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BFormTextarea, BFormCheckbox, BPopover, VBToggle, BImg, BLink , BFormRadioGroup, BFormRadio, BCollapse} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import { ref, watch, provide } from '@vue/composition-api'
import { $themeConfig } from '@themeConfig'
import InvoiceSidebarAddNewCustomer from '@/components/SidebarAddNewCustomer'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import { VueAutosuggest } from 'vue-autosuggest'
import currency from '@/utils/currency'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import VSelectValidated from '@/components/forms/vSelectValidated.vue'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import invoiceUtils from '@/hooks/invoiceUtils'
import { addInvoice } from '@/composables/invoiceService'

export default {
  components: { BRow, BCol, BCard, BCardBody, BButton, BCardText, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BFormTextarea, BFormCheckbox, BPopover, flatPickr, vSelect, InvoiceSidebarAddNewCustomer, BImg, BLink, BFormRadioGroup, BFormRadio, VueAutosuggest, VSelectValidated, TextInputValidated, BCollapse },
  directives: { Ripple, 'b-toggle': VBToggle },
  mixins: [heightTransition],
  setup() {
    const {invoice, item, getItemTaxableBase, calculateInvoice, setBankAccount, setBillingData, validateInvoice, changeToCurrentTax, updateDiscountTax, vatBeforeUpdated, pitBeforeUpdated, discountBeforeUpdated, updateItemForm, onItemInputChange, onCustomerInputChange, paymentMethodsOptions, itemsOptions, customerOptions, vatsOptions, pitsOptions, groupsOptions, cashesOptions, settings, fetchStudents, fetchAccounts, itemsSuggestions, customersSuggestions, addNewItemInItemForm, removeItem, type, updateCustomerForm, invoicePit, setCashVisibility, setTaxesVisibility, applyPIT, applyVAT, showCashes, economicActivityOptions, itemTypeOptions, fetchAccountingAccounts, accountingAccountOptions, onItemTypeInput, onAccountingInput, setEconomicActivity} = invoiceUtils()
  
    const { formatCurrency } = currency()
    const { appName, appLogoImage } = $themeConfig.app
    const { errorToast } = popups()
    const flatpickrOptions = {
      plugins: [
        new monthSelectPlugin({
          shorthand: true,
          dateFormat: "m-Y",
          altFormat: "F Y",
            }),
      ],
    };
    const isSidebarActive=ref(false);
    provide('isSidebarActive', isSidebarActive)
    let timer = ref(0)
    const delay = 500
    const typeOptions= [
      { text: "Factura", value: "invoice" },
      { text: 'Recibo', value: "receipt" },
    ]
    type.value="receipt"

    fetchAccountingAccounts(1).then((response)=>{accountingAccountOptions.value=response})


    // Métodos

    const submit = async function (){
      // Validaciones
      let valid = validateInvoice()
      if(!invoice.value.customer) { errorToast('Selecciona un cliente'); return false }
      if (invoice.value.customer.is_legal_entity && invoice.value.customer.is_legal_entity == 1  ) {
        invoice.value.is_legal_entity=true
      } else {
        invoice.value.is_legal_entity=false
      }
      if (!valid) return

      if ( (invoice.value.settings_address == "" || invoice.value.settings_city == "" || invoice.value.settings_province == "" || invoice.value.settings_country == "" || invoice.value.settings_phone == "") ) {
            errorToast("Faltan datos de facturación de la empresa. Añádelos en la configuración general o en las de tu sucursal."); return false;
        }



      if (type.value=="invoice") {
        invoice.value.n_invoice=true
        invoice.value.n_receipt=null
      }else if (type.value=="receipt") {
        invoice.value.n_receipt=true
        invoice.value.n_invoice=null
      }

      invoice.value.customer.dni ? invoice.value.student_id=invoice.value.customer.id : invoice.value.account_id=invoice.value.customer.id
      invoice.value.group_id=invoice.value.group.id
      invoice.value.customer = null
      document.getElementById('submitbutton').disabled=true;
      let response = await addInvoice(invoice.value)
      response.data.success ? this.$router.push({ name: 'invoices' }) : errorToast(response.data.msg)
      document.getElementById('submitbutton').disabled=false;
    }

    watch(invoice, () => {
      setCashVisibility()
      setTaxesVisibility()
      calculateInvoice()
    }
    , {deep:true}
    )

    watch(() => invoice.value.group, () => {
      setSerie()
      setBillingData()
      setBankAccount()
    })
    
    watch(type, () => {
      setSerie()
    })



    watch(()=> [invoice.value.customer, invoice.value.payment_method], () => {
      setBankAccount()
    })



    const setSerie = () => {
      if (invoice.value.group) {
        if (type.value == 'receipt' && invoice.value.group.receipt_series.length==1) {
          invoice.value.serie = invoice.value.group.receipt_series[0]
          invoice.value.economic_activity_id=invoice.value.serie.economic_activity_id
        } else if (type.value == 'receipt') {
          invoice.value.serie = null
          invoice.value.economic_activity_id = null
        }

        if (type.value == 'invoice' && invoice.value.group.invoice_series.length==1) {
          invoice.value.serie = invoice.value.group.invoice_series[0]
          invoice.value.economic_activity_id=invoice.value.serie.economic_activity_id
        } else if (type.value == 'invoice') {
          invoice.value.serie = null
          invoice.value.economic_activity_id = null
        }

      }
    }
    
    return {
      updateCustomerForm,
      updateItemForm,
      paymentMethodsOptions,
      itemsOptions,
      appLogoImage,
      customerOptions,
      appName,
      invoice,
      submit,
      item,
      vatsOptions,
      pitsOptions,
      updateDiscountTax,
      discountBeforeUpdated ,
      vatBeforeUpdated,
      pitBeforeUpdated,
      changeToCurrentTax,
      fetchStudents,
      fetchAccounts,
      isSidebarActive,
      typeOptions,
      type,
      onItemInputChange,
      itemsSuggestions,
      customersSuggestions,
      applyPIT,
      applyVAT,
      groupsOptions,
      cashesOptions,
      showCashes,
      formatCurrency,
      flatpickrOptions,
      getItemTaxableBase,
      onCustomerInputChange, 
      settings,
      addNewItemInItemForm, 
      removeItem,
      invoicePit,
      economicActivityOptions,
      itemTypeOptions,
      accountingAccountOptions,
      onItemTypeInput,
      onAccountingInput,
      setEconomicActivity
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/vue/libs/vue-flatpicker.scss';
@import '~@core/scss/vue/libs/vue-autosuggest';
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}

.flatpickr-monthSelect-months {
    width:100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .flatpickr-monthSelect-month {
    display: inline-block;
    padding:0.4em 1em;
    
  }
  .flatpickr-monthSelect-month:hover {
    cursor:pointer;
  }

  .flatpickr-innerContainer {
    display:block;
  }
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/pages/app-invoice.scss';
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}

.invoice-total-wrapper{
    max-width: 272px !important;
}
</style>
